module.exports = __webpack_public_path__ + "assets/img/D.a352cf1e.png";